import React from 'react';
import NextArrow from 'react-icons/lib/md/arrow-forward';
import PrevArrow from 'react-icons/lib/md/arrow-back';

import './cardControls.less';

const CardControls = (props) => {
	return (
		<div className="card-controls">
			<button type="button" className="card-controls-nav left" aria-label="Previous" onClick={props.onPrevious}>
				<PrevArrow />
			</button>
			<button type="button" className="card-controls-nav right" aria-label="Next" onClick={props.onNext}>
				<NextArrow />
			</button>
			<button type="button" className="card-controls-close" aria-label="Close" onClick={props.onClose}>
				<span role="img" aria-label="x">❌</span>
			</button>
		</div>
	);
};

export default CardControls;



// WEBPACK FOOTER //
// ./src/react/card/CardControls.jsx